import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { select } from '@ngxs/store';
import { BasicPage, GtmClickDirective, NewsletterComponent, TrainingType, WwwRouteSlug } from '@pro-connect/shared';
import { AccountHomeTopComponent } from './components/account-home-top/account-home-top.component';
import { TrainingsListComponent } from 'shared/src/pages/core/components/trainings-list/trainings-list.component';
import { TrainingsListState } from 'shared/src/pages/core/components/trainings-list/trainings-list.state';

@Component({
  templateUrl: './account-home.component.html',
  styleUrls: ['./account-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NewsletterComponent, AccountHomeTopComponent, RouterModule, TrainingsListComponent, GtmClickDirective],
})
export class AccountHomeComponent extends BasicPage {
  public override readonly loading = select(TrainingsListState.loading);
  protected readonly TrainingType = TrainingType;
  protected readonly WwwRouteSlug = WwwRouteSlug;

  constructor() {
    super();
  }
}
